import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatINR } from "@/lib/helpers";
import { Warning } from "@phosphor-icons/react";

export default function Inventory() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/products", { params: { limit: 500 } }).then(r => setItems(r.data.items)); }, []);
  const low = items.filter(p => (p.stock ?? 0) > 0 && (p.stock ?? 0) < 10);
  const oos = items.filter(p => (p.stock ?? 0) === 0);

  return (
    <div className="space-y-6 min-w-0" data-testid="inventory-page">
      <div>
        <div className="eyebrow mb-1">Inventory</div>
        <h1 className="font-display font-bold text-3xl lg:text-4xl tracking-tighter text-navy">Stock levels</h1>
        <p className="text-muted-foreground mt-2 text-sm">Real-time stock across all master products.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <div className="kpi-card"><div className="kpi-label">SKUs</div><div className="kpi-value">{items.length}</div></div>
        <div className="kpi-card"><div className="kpi-label">In stock</div><div className="kpi-value text-brand-green">{items.length - low.length - oos.length}</div></div>
        <div className="kpi-card"><div className="kpi-label">Low stock</div><div className="kpi-value text-orange">{low.length}</div></div>
        <div className="kpi-card"><div className="kpi-label">Out of stock</div><div className="kpi-value text-red-600">{oos.length}</div></div>
      </div>

      <div className="card-base overflow-hidden">
        <div className="p-4 border-b border-border flex items-center gap-2">
          <Warning size={16} weight="fill" className="text-orange"/>
          <div className="section-title">Needs attention</div>
        </div>
        <div className="scroll-x">
          <table className="table-base">
            <thead><tr>
              <th>Product</th><th>MPC ID</th><th>SKU</th>
              <th className="text-right">Stock</th><th className="text-right">Price</th><th>Status</th>
            </tr></thead>
            <tbody>
              {[...oos, ...low].map(p => (
                <tr key={p.id}>
                  <td>
                    <div className="flex items-center gap-3 min-w-0">
                      {p.images?.[0]?.url && <img src={p.images[0].url} className="w-8 h-8 border border-border rounded object-cover shrink-0" alt="" onError={(e)=>{e.target.style.visibility='hidden';}}/>}
                      <span className="font-medium text-navy truncate">{p.name}</span>
                    </div>
                  </td>
                  <td className="font-mono-data text-xs">{p.mpc_id}</td>
                  <td className="font-mono-data text-xs">{p.sku||"—"}</td>
                  <td className="text-right font-mono-data tabular-nums">{p.stock ?? 0}</td>
                  <td className="text-right font-mono-data tabular-nums">{formatINR(p.selling_price)}</td>
                  <td><span className={`pill ${(p.stock??0)===0?"pill-missing":"pill-draft"}`}>{(p.stock??0)===0?"OUT OF STOCK":"LOW STOCK"}</span></td>
                </tr>
              ))}
              {[...oos, ...low].length === 0 && <tr><td colSpan={6} className="text-center text-muted-foreground py-8 text-sm">All products well-stocked.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
